import React from 'react';

import { Box, Text, VStack } from '@betterment/samba-react';
import { ModalContent, ModalOverlay, Typist } from '@betterment/style-closet-react';
import styled from '@emotion/styled';
import VisuallyHidden from '@reach/visually-hidden';

import AnimatedCheckmark from './AnimatedCheckmark';

const Content = styled(ModalContent)<{ $noPadding?: boolean }>`
  &&& {
    max-width: none;
    width: 100%;
  }

  ${({ $noPadding }) =>
    $noPadding &&
    `
    &[data-reach-dialog-content] {
      padding: 0;
      margin: 0;
    }
  `}
`;

export interface SuccessOverlayProps {
  message: string;
  onCompletion?: () => void;
  noPadding?: boolean;
}

const SuccessOverlay: React.FC<React.PropsWithChildren<SuccessOverlayProps>> = ({
  message,
  onCompletion,
  noPadding,
}) => {
  return (
    <ModalOverlay>
      <Content my="0" mx="0" aria-label={message} $noPadding={noPadding}>
        <VStack
          css={{
            p: 'space.150',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'background.abyss',
          }}
        >
          <Box css={{ mb: 'space.300' }}>
            <AnimatedCheckmark />
          </Box>
          <VisuallyHidden>
            <Text>{message}</Text>
          </VisuallyHidden>
          <Typist onTypingDone={onCompletion} startDelay={500}>
            <Text
              color="text.inverse"
              css={{
                fontWeight: 'bold',
                lineHeight: 'lineHeight.100',
                fontSize: 'fontSize.300',
              }}
            >
              {message}
            </Text>
            <Typist.Delay ms={800} />
          </Typist>
        </VStack>
      </Content>
    </ModalOverlay>
  );
};

export default SuccessOverlay;
